// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3TTGt","addWidgetButton":"Header_addWidgetButton__hPL5Z","dashboardTabs":"Header_dashboardTabs__CL-0S","active":"Header_active__1vTjs"};